// Import locales pack for veutify (add / remove desired locales)

import { zhHant, ja, en,zhHans } from 'vuetify/locale'
import BUSINESS_DATA from './businessConstants'

import { aliases, mdi } from 'vuetify/iconsets/mdi'

import { md2 } from 'vuetify/blueprints'
/**
 * Vuetify configuration options
 * @type {import('vuetify').VuetifyOptions}
 */
export default {
  blueprint: md2, // use material design v2 blueprint as base
  /**
   * Defines icon settings in vuetify
   * Currently installed fonts: [mdi, FontAwesome6]
   * @see https://vuetifyjs.com/en/features/icon-fonts/
   */
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  /**
   * Defines i18n settings in vuetify
   * @see https://vuetifyjs.com/en/features/internationalization/
   */
  locale: {
    messages: { ja, zhHant, en,zhHans },
    fallback: 'ja',
  },
  /**
   * Defines theme related settings in vuetify
   * @see https://vuetifyjs.com/en/features/theme/
   */
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        colors:{
          primary: BUSINESS_DATA.APP_PRIMARY_COLOR,
          secondary: BUSINESS_DATA.APP_SECONDARY_COLOR,
          "on-primary": BUSINESS_DATA.APP_ON_PRIMARY_COLOR,
        }
      }
    }
  },
  defaults: {
    VBtn: { variant: 'elevated', color:"null" },
    VCardActions:{
      VBtn: { variant: 'elevated', color:"null" },
    },
    VDataTableServer:{
      mobileBreakpoint: 600,
      itemsPerPage:30,
      density:'comfortable',
      itemsPerPageOptions: [10, 20, 30, 40, 50]
    },
    VCheckbox:{
      color: BUSINESS_DATA.APP_PRIMARY_COLOR,
      // density:'comfortable',
      hideDetails:true,
    },
    VRadio:{
      color: BUSINESS_DATA.APP_PRIMARY_COLOR,
      hideDetails:true,
    },
    VRadioGroup:{
      color: BUSINESS_DATA.APP_PRIMARY_COLOR,
      hideDetails:true,
    },
    VSwitch:{
      color: BUSINESS_DATA.APP_PRIMARY_COLOR,
    },
  },
  display: {
    mobileBreakpoint: 600,
  },
}
